/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './medication-history.reducer';

export const MedicationHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const medicationHistoryEntity = useAppSelector(state => state.medicationHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="medicationHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.medicationHistory.detail.title">MedicationHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.id}</dd>
          <dt>
            <span id="medicationFor">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.medicationFor">Medication For</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.medicationFor}</dd>
          <dt>
            <span id="medicationStartDate">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.medicationStartDate">Medication Start Date</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.medicationStartDate}</dd>
          <dt>
            <span id="medicationEndDate">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.medicationEndDate">Medication End Date</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.medicationEndDate}</dd>
          <dt>
            <span id="medicationDetails">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.medicationDetails">Medication Details</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.medicationDetails}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.medicationHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{medicationHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationHistory.patient">Patient</Translate>
          </dt>
          <dd>{medicationHistoryEntity.patient ? medicationHistoryEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/medication-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/medication-history/${medicationHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MedicationHistoryDetail;
